import { render } from "./StartType.vue?vue&type=template&id=dfea8278"
import script from "./StartType.vue?vue&type=script&lang=js"
export * from "./StartType.vue?vue&type=script&lang=js"

import "./StartType.vue?vue&type=style&index=0&id=dfea8278&lang=scss"

import exportComponent from "/builds/lindner/lindner-factorytour-frontend-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__